import React from "react"

import { Block, Grid, Spacer } from "../atoms/layout-primitives"

import AccentTitleDivider from "../../components/shared/accent-title-divider/accent-title-divider"

import { graphql } from "gatsby"
import FAQItem, {
  IFAQItemProps,
  IRichTextFAQItemProps,
} from "../atoms/faq-item"

interface IFaqSectionProps {
  title?: String
  items: IFAQItemProps[]
}

export default function FaqSection({ title, items }: IFaqSectionProps) {
  return (
    <>
      {title && (
        <>
          <AccentTitleDivider>{title}</AccentTitleDivider>
          <Spacer height={{ sm: "32px", md: "48px", lg: "96px" }} />{" "}
        </>
      )}
      <Grid>
        <Block col={{ sm: "1 / -1", lg: "3 / -3" }}>
          {items.map((question, index) => (
            <FAQItem {...question} key={index} />
          ))}
        </Block>
      </Grid>
      <Spacer
        height={{ sm: "48px", lg: "96px" }}
        variants={{ sm: { borderBottom: "1px solid #2E2E2E28" } }}
      />
    </>
  )
}

export interface IContentfulFAQs {
  __typename: "ContentfulFrequentlyAskedQuestions"
  faqItems: IRichTextFAQItemProps[]
}

/** Adapter for Contentful FAQs to FAQ item components */
export const ContentfulFAQs = ({
  faqItems,
}: Omit<IContentfulFAQs, "__typename">) => (
  <Grid>
    <Block col={{ sm: "1 / -1", lg: "3 / -3" }}>
      {Array.isArray(faqItems)
        ? faqItems.map((question, index) => (
            <FAQItem.RichText {...question} key={index} />
          ))
        : null}
    </Block>
  </Grid>
)

export const FAQFragment = graphql`
  fragment ContentfulFrequentlyAskedQuestions on ContentfulFrequentlyAskedQuestions {
    contentful_id
    faqItems {
      title
      body {
        raw
      }
    }
  }
`
export const FAQ_TYPENAME = "ContentfulFrequentlyAskedQuestions"
